import { render, staticRenderFns } from "./ProgramCustomization.vue?vue&type=template&id=32daeef6&lang=pug&"
import script from "./ProgramCustomization.vue?vue&type=script&lang=js&"
export * from "./ProgramCustomization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports